import { render } from "./book-img.vue?vue&type=template&id=07157a90&scoped=true"
import script from "./book-img.vue?vue&type=script&lang=js"
export * from "./book-img.vue?vue&type=script&lang=js"

import "./book-img.vue?vue&type=style&index=0&id=07157a90&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07157a90"]])

export default __exports__